import React from 'react';
import ReactLoading from 'react-loading';
import { LoadingHolder } from './style';
import { color } from 'styles/settings';

function BarsLoader() {
  return (
    <LoadingHolder>
      <ReactLoading type={'bars'} width={100} color={color.brand.gold} />
    </LoadingHolder>
  );
}

export default BarsLoader;
